/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Async state management constants
 *
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.11.0
 */

/*
* -------------------------------------------
*             Init & Unmount
* -------------------------------------------
*/

export const ASYNC_STATE_MANAGEMENT_INIT = '@@b2b_portal_ui/asyncStateManagement/ASYNC_STATE_MANAGEMENT_INIT';
export const ASYNC_STATE_MANAGEMENT_INIT_SUCCESS =
    '@@b2b_portal_ui/asyncStateManagement/ASYNC_STATE_MANAGEMENT_INIT_SUCCESS';
export const ASYNC_STATE_MANAGEMENT_UNMOUNT = '@@b2b_portal_ui/asyncStateManagement/ASYNC_STATE_MANAGEMENT_UNMOUNT';
export const ASYNC_STATE_MANAGEMENT_UNMOUNT_SUCCESS =
    '@@b2b_portal_ui/asyncStateManagement/ASYNC_STATE_MANAGEMENT_UNMOUNT_SUCCESS';

/*
* -------------------------------------------
*             Save state
* -------------------------------------------
*/

export const ASYNC_STATE_MANAGEMENT_SAVE = '@@b2b_portal_ui/asyncStateManagement/ASYNC_STATE_MANAGEMENT_SAVE';
